<div class="row">
  <div class="col-lg-8 col-md-6" [innerHtml]="aboutUsContent"></div>

  <div class="col-lg-4 col-md-6">
    <app-contact-us></app-contact-us>
  </div>
</div>